<template>
   <div class="refs_list_container">
      <div class="sight_ref_tabs_container">

            <div class="sight_ref_tabs_slider_container" ref="catSliderContainer">
                <div class="sight_ref_tabs" v-bind:style="barStyle" ref="catSlider">

                    <div class="ref_tab_item" @click="changeCat(-1)" :class="{active: currentCatId == -1}" >{{ $t('modules.refs.index.refsList.catsAllRefs') }}</div>
                    <div class="ref_tab_item" @click="changeCat(-2)" :class="{active: currentCatId == -2}" v-if="userData.referent" >
                        {{ $t('modules.refs.index.refsList.teamRefs') }}
                    </div>
                    <CatItem
                        v-for='(cat, index) in customCats'
                        :index="index"
                        :key="cat.id"
                        :cat='cat'
                        :isActive="currentCatId == cat.id"
                        @click="changeCat(cat.id)"
                        @removeCatClicked="removeCat(cat)"
                        @drop="onDrop">
                    </CatItem>

                </div>
            </div>

            <CatsActions @slideRight="slideRight" @slideLeft="slideLeft" />
        </div>

        <div class="content_section">
            <div class="container">

                <div class="order_refs">
                    <div class="select">
                        <select  v-model="sortRefData" @change="changeRefsOrder">
                            <option :value="{field: 'name', order: 'asc'}">{{ $t('modules.refs.index.refsList.sortOption1') }}</option>
                            <option :value="{field: 'name', order: 'desc'}">{{ $t('modules.refs.index.refsList.sortOption2') }}</option>
                            <option :value="{field: 'created_at', order: 'desc'}">{{ $t('modules.refs.index.refsList.sortOption3') }}</option>
                            <option :value="{field: 'created_at', order: 'asc'}">{{ $t('modules.refs.index.refsList.sortOption4') }}</option>
                        </select>
                    </div>
                </div>

                <div class="sight_refs_list"  >
                    <NewRefItem />

                    <RefListItem
                        v-for="(refItem, index) in currentRefs"
                        v-bind:index="index"
                        v-bind:key="refItem.id"
                        v-bind:refItem='refItem'
                        @dragstart="dragStart" />

                </div>

                <nav class="pagination table-pagination is-centered is-medium">
                    <paginate
                        :page-count="totaPages"
                        :click-handler="OnPageChange"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :page-link-class="'pagination-link'"
                        :active-class="'is-current'"
                        :prev-link-class="'pagination-link'"
                        :next-link-class="'pagination-link'"
                        :disabled-class="'is-disabled'"
                        :container-class="'pagination-list'">
                    </paginate>
                </nav>

            </div>
        </div>
    </div>
</template>

<script>
import RefListItem from "./refListItem"
import NewRefItem from "./newRefItem"
import CatItem from "./catItem"
import CatsActions from "./catsActions"

export default {
    name: 'RefsList',
    components: {
        RefListItem,
        NewRefItem,
        CatItem,
        CatsActions
    },
    data(){
        return {
            slidingStep: 100,
            catSlidingValue: 0,
            movedRef: null,
            sortRefData: {field: 'name', order: 'asc'},
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },
    computed: {
        barStyle(){
            return {left: this.catSlidingValue + 'px'}
        },
        currentCatId(){
            return this.$store.state.RefStore.currentCatId
        },
        currentRefs(){
            return this.$store.state.RefStore.customRefs
        },
        customCats(){
            return this.$store.state.RefStore.customCats
        },
        totaPages(){
            return this.$store.state.RefStore.totalPages
        }
    },
    methods: {
        changeCat(catId){
            this.$store.dispatch('RefStore/CustomRefsList', {cat_id: catId, page: 1})
        },
        OnPageChange(currentpage){
            this.$store.dispatch('RefStore/CustomRefsList', {page: currentpage})
        },
        onDrop(event, cat){
            this.assignCat(cat)
        },
        dragStart(event, movedRef){
            this.movedRef = movedRef
        },
        changeRefsOrder(){
            const data = {
                sort_column: this.sortRefData.field,
                sort_type: this.sortRefData.order
            }
            this.$store.dispatch('RefStore/CustomRefsList', data)
        },
        assignCat(cat){
            this.movedRef.sight_ref_cat_id = cat.id
            this.$store.dispatch('RefStore/saveRef', this.movedRef).then(() => {
                this.$store.dispatch('RefStore/CustomRefsList', {})
                this.$store.dispatch('RefStore/indexCats', "custom")
            })
        },
        slideLeft(){
            const max = 0
            const newVal = this.catSlidingValue + this.slidingStep
            if(newVal > max) {
                this.catSlidingValue = max
            }else{
                this.catSlidingValue = newVal
            }
        },
        slideRight(){
            const max =  this.$refs.catSliderContainer.clientWidth - this.$refs.catSlider.clientWidth
            const newVal = this.catSlidingValue - this.slidingStep
            if(newVal < max){
                this.catSlidingValue = max
            }else{
                this.catSlidingValue = newVal
            }
        },
        removeCat(cat){
            this.$store.dispatch('RefStore/deleteCat', cat).then(() => {
                if (cat.id == this.currentCatId){
                    this.currentCatId = -1
                }
                this.$store.dispatch('RefStore/indexCats', "custom")
            })
        }

    }
}
</script>

<style lang="scss">
.sight_refs_list{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.order_refs{
    text-align: center;
    padding: 50px 0 30px;
    .select{
        height: 42px!important;
        select{
            background-color: $info;
            color: white;
            padding-top: 5px;
            padding-left: 20px;
            height: 42px;

        }
        &:after{
            border-color: $white!important;
        }
    }
}

.sight_ref_tabs_container{
    background-color: $white;
    display: flex;

    .sight_ref_tabs_slider_container{
        overflow: hidden;
        position: relative;
        height: 33px;
        flex: 1;
        .sight_ref_tabs{
            display: flex;
            justify-content: center;
            position: absolute;
            left: 0px;
            min-width: 100%;
            transition: 0.5s all;
        }
    }

}
</style>